export const PAGE_NOT_FOUND_ERROR_TITLE = "Oooops! We could’t find this page";
export const PAGE_NOT_FOUND_ERROR_SUBTITLE =
  "The page is missing or you assembled the link incorrectly";
export const PAGE_NOT_FOUND_ERROR_BUTTON_TEXT = "Go back";
